import {costumeCategoryApi} from '../api/costumeCategoryApi';
import {
    CostumeCategory,
    CreateCostumeCategoryRequest,
    PatchCostumeCategoryRequest,
} from '../types/costumeCategory';
import {
    useBaseMutation,
    useBaseQuery,
    useInvalidateQueries,
    useNoDataMutation,
} from './useBaseQuery';
import {eppiCostumeKeys} from './useEppiCostumes';

export const costumeCategoryKeys = {
    all: ['costumeCategory'] as const,
    lists: () => [...costumeCategoryKeys.all, 'list'] as const,
    list: () => [...costumeCategoryKeys.lists()] as const,
};

export const useCostumeCategories = () => {
    return useBaseQuery<CostumeCategory[]>(
        costumeCategoryKeys.list(),
        () => costumeCategoryApi.getAll(),
        {staleTime: 5 * 60 * 1000}
    );
};

export const useCreateCostumeCategory = () => {
    const {invalidate, invalidateMultiple} = useInvalidateQueries();
    return useBaseMutation<CreateCostumeCategoryRequest, CostumeCategory>(
        (req) => costumeCategoryApi.create(req),
        {
            onSuccess: () => {
                invalidate(costumeCategoryKeys.lists());
                invalidateMultiple([eppiCostumeKeys.all]);
            },
        }
    );
};

export const usePatchCostumeCategory = () => {
    const {invalidate, invalidateMultiple} = useInvalidateQueries();
    return useBaseMutation<
        {id: number; data: PatchCostumeCategoryRequest},
        CostumeCategory
    >(({id, data}) => costumeCategoryApi.update(id, data), {
        onSuccess: () => {
            invalidate(costumeCategoryKeys.lists());
            invalidateMultiple([eppiCostumeKeys.all]);
        },
    });
};

export const useDeleteCostumeCategory = () => {
    const {invalidate, invalidateMultiple} = useInvalidateQueries();
    return useNoDataMutation<number>((id) => costumeCategoryApi.delete(id), {
        onSuccess: () => {
            invalidate(costumeCategoryKeys.lists());
            invalidateMultiple([eppiCostumeKeys.all]);
        },
    });
};

export const useNormalizeCostumeCategories = () => {
    const {invalidate, invalidateMultiple} = useInvalidateQueries();
    return useNoDataMutation<void>(
        () => costumeCategoryApi.normalize(),
        {
            onSuccess: () => {
                invalidate(costumeCategoryKeys.lists());
                invalidateMultiple([eppiCostumeKeys.all]);
            },
        }
    );
};
